import { Head } from '@inertiajs/react';
import { ArcadeDebug } from './components/arcade-debug';

export default function Debug() {
  return (
    <>
      <Head title="Arcade Controls Debug | Platanus Hack">
        <meta
          name="description"
          content="Inspect raw keyboard and USB gamepad input to configure arcade cabinet control mappings."
        />
      </Head>
      <ArcadeDebug />
    </>
  );
}
